import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as tag from "./Project.style"
import Card from './SubComponents/Card.component'
import Loader from "../Loader/Loader.component"
import Navbar from "../Navbar/Navbar";


export default class ProjectComponent extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: true,
			bgColor: this.props.bgColor,
			heading: this.props.heading,
			projects: []
			// totalProjects: 0
		}
	}

	componentDidMount(){
		fetch(
			"https://sheets.googleapis.com/v4/spreadsheets/1WFacDnB1Ro-1Zs3SRcxR3hcLH_Swnkv5o-_4faKi5jg/values:batchGet?ranges=A2:U133&key=AIzaSyATGC19rqvjo4HJs8uMHFoittxEeoNViPs"
		)
		.then((res) => res.json())
		.then((data) => {
			var projects = data.valueRanges[0].values;
			console.log(projects[0]);
			setTimeout(() => {
				this.setState({
					loading: false,
					projects
				})
			}, 2000);
		})
	}

	componentWillUnmount(){}

	static propTypes = {
		bgColor: PropTypes.string.isRequired,
		heading: PropTypes.string.isRequired
	}

	render() {
		return (
			<tag.Container bgColor={this.state.bgColor} >
				{
					this.state.loading === true 
					? <Loader />
					: <tag.SubContainer>
						<Navbar/>
						<tag.HeadingContainer>
							<tag.Heading>{this.state.heading}</tag.Heading>
						</tag.HeadingContainer>
						<tag.CardContainer>
							{
								this.state.projects.map((project) => {
									if(project[12] === "Yes")
										return <Card project={project} key={project[0]} />
									else
										return <></>
								})
							}
						</tag.CardContainer>
					</tag.SubContainer>

				}
			</tag.Container>
		)
	}
}